import { i18nObject } from 'boot/i18n'
import { useHelpers } from 'src/common/composition/useHelpers'

export function notification(messageOptions, context) {
  const $helpers = useHelpers(context)

  const {
    text,
    title,
    timer,
    dateTime,
    type = 'info',
    canClose = true,
    message = false,
    actions = [],
    html,
    propsContent,
    customIcon,
    iconName,
    color,
  } = messageOptions
  $helpers.notify({
    message: title || i18nObject.global.t('notification'),
    caption: text || '',
    dateTime,
    propsContent,
    position: 'top-right',
    timeout: timer || 5000,
    type,
    canClose,
    actions,
    classes: message && '--message',
    html: html,
    customIcon,
    iconName,
    systemIcon: type,
    color,
  })
}

export function errorHandling(error, notify = true) {
  const errorsMessages = error.graphQLErrors?.map(({ message }) => message)?.join('. ') ?? ''
  const errorsDetails = error.graphQLErrors?.map(({ extensions }) => extensions?.detail)?.join('. ') ?? ''
  if (errorsMessages.length || errorsDetails.length) {
    if (notify) {
      notification({ text: errorsDetails || errorsMessages })
    }
    return errorsDetails || errorsMessages
  } else {
    const fallbackMessage = i18nObject.global.t('serverErrorTryAgain')
    if (notify) {
      notification({ text: fallbackMessage })
    }
    return fallbackMessage
  }
}
